<template>
  <main>
    <section v-if="orderConfirmWrapper.settlementAmount">
      <div class="merchant_wrapper">
        <OrderPayInfo></OrderPayInfo>
        <div class="pay_wrapper">
          <div class="pay_title">支付方式</div>
<!--          <div :class="payType === 1 ? 'pay_box_selected': 'pay_box'" @click="changePayType(1)">-->
<!--            <img style="width: 32px; height: 32px; margin-top: 10px; margin-bottom: 6px;" src="/static/images/test/wxpay.png">-->
<!--            <span style="margin-left: 10px; margin-top: 14px; color: #333;">微信支付</span>-->
<!--          </div>-->

          <div :class="payType === 3 ? 'pay_box_selected': 'pay_box'" @click="changePayType(3)">
            <img style="width: 36px; height: 28px; margin-top: 10px; margin-bottom: 6px;" src="/static/images/pay.png">
            <span style="margin-left: 10px; margin-top: 14px; color: #333;">扫码支付</span>
          </div>

<!--          <div class="pay_box">-->
<!--            <img style="width: 36px; height: 28px; margin-top: 10px; margin-bottom: 6px;" src="/static/images/pay.png">-->
<!--            <span style="margin-left: 10px; margin-top: 14px; color: #333;">扫码支付</span>-->
<!--          </div>-->
          <p class="pay_tips"><i class="el-icon-info"></i> 本商品为虚拟内容服务，购买后不支持退款、转让。</p>
          <p class="pay_tips"><i class="el-icon-info"></i> 本公司严格保障付费用户的合法权益，如果遇到支付方面的问题，可以在微信支付账单中获取到我们的联系电话，我们会竭尽所能为您解决。</p>
        </div>

        <div class="pay_button_wrapper">
          <el-button class="pay_button" type="warning" round icon="el-icon-shopping-cart-2" :disabled="paying" @click="pay()">{{btn}}</el-button>
        </div>
      </div>

    </section>

    <Footer></Footer>
  </main>
</template>

<script>
import OrderPayInfo from '@/components/OrderPayInfo'
import Footer from '@/components/Footer'
import {mapGetters, mapState} from 'vuex'
import {
  reqSaveOrder,
  reqSaveOrder4Pic,
  reqSaveOrder4PicUpgrade,
  reqCheckPayStatus
} from '@/api'

export default {
  name: 'OrderConfirm',
  components: {OrderPayInfo, Footer},

  data() {
    return {
      btn: '确认支付',
      timesRun: 0,
      interval: {},
      intervalCleaned: false,
      payInfo: {},
      paying: false,
      payType: 3 //1-微信 3-拉卡拉
    }
  },

  async mounted () {
    if (!this.isLogin) {
      await this.$router.push('/index')
      return
    }

    if (!this.orderConfirmWrapper.productKey) {
      await this.$router.push('/index')
    }

    // console.log(this.orderConfirmWrapper)

  },

  methods: {
    changePayType (v) {
      this.payType = v
    },

    async pay (index) {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.btn = '支付中'
      this.paying = true
      const payType = this.payType == 1 ? 'wx' : 'lkl'
      let result
      if (this.orderConfirmWrapper.resType === 1) {
        if (this.orderConfirmWrapper.purchaseType === 3) {
          result = await reqSaveOrder4PicUpgrade(payType, this.orderConfirmWrapper.productKey,
            this.orderConfirmWrapper.settlementAmount,
            this.orderConfirmWrapper.no,
            this.orderConfirmWrapper.purchaseType,
            this.orderConfirmWrapper.licenseCount,
            this.orderConfirmWrapper.duration,
            this.orderConfirmWrapper.unit,
            this.orderConfirmWrapper.recordId,
            this.orderConfirmWrapper.lastAliOrderId,
            this.orderConfirmWrapper.gapUnitPrice
          )
        } else {
          result = await reqSaveOrder4Pic(payType, this.orderConfirmWrapper.productKey,
            this.orderConfirmWrapper.settlementAmount,
            this.orderConfirmWrapper.no,
            this.orderConfirmWrapper.purchaseType,
            this.orderConfirmWrapper.licenseCount,
            this.orderConfirmWrapper.duration,
            this.orderConfirmWrapper.unit,
            this.orderConfirmWrapper.recordId
          )
        }

      } else {
        result = await reqSaveOrder(payType, this.orderConfirmWrapper.productKey,
          this.orderConfirmWrapper.settlementAmount,
          this.orderConfirmWrapper.purchaseType,
          this.orderConfirmWrapper.tokenNumber,
          this.orderConfirmWrapper.duration,
          this.orderConfirmWrapper.qps,
          this.orderConfirmWrapper.licenseCount,
          this.orderConfirmWrapper.unitPrice,
          this.orderConfirmWrapper.lastAliOrderId,
          this.orderConfirmWrapper.remainMonths,
          this.orderConfirmWrapper.lastTokenNumber,
          this.orderConfirmWrapper.upgradeUnitPrice,
          this.orderConfirmWrapper.note
        )
      }

      loading.close()
      if (result.code === 0) {
        const payInfo = result.data

        if (this.payType === 1) { // 微信支付
          await this.$store.dispatch('setPayInfo', {payInfo})
          this.$router.push({
            path: '/pay'
          }).catch(err=>{})

        } else {  // 拉卡拉支付
          // this.payInfo = result.data
          // 打开新的页面
          window.open(result.data.codeUrl, '_blank')
          let that = this
          // 每5秒发起一次查询
          that.interval = setInterval(async () => {
            that.timesRun += 1;
            if(that.timesRun >= 900){
              that.intervalCleaned = true
              clearInterval(that.interval)
              await this.$alert("支付超时，请重新购买", '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  that.$router.replace('/')
                }
              })
            }

            const checkResult = await reqCheckPayStatus(payInfo.orderNo)
            if (checkResult.code === 0) {
              if (checkResult.data.payStatus === 1) {
                that.intervalCleaned = true
                clearInterval(that.interval)
                await this.$router.replace('/payConfirm')
              } else if (checkResult.data.payStatus === 2) {
                that.intervalCleaned = true
                clearInterval(that.interval)

                await this.$alert("支付失败，请稍后重新购买", '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    that.$router.replace('/')
                  }
                })
              }
            } else {
              that.intervalCleaned = true
              clearInterval(that.interval)
              await this.$alert("系统异常，请稍后重新购买", '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  that.$router.replace('/')
                }
              })
            }
          }, 5000);
        }

      } else {
        await this.$alert("支付异常，请稍后再试", '错误', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
      }
    },

  },

  computed: {
    ...mapState(['orderConfirmWrapper']),
    ...mapGetters(['isLogin']),
  }

}
</script>

<style scoped>

  main {
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  section {
    height: 100vh;
    display: flex;
    flex-direction: column;
    padding-top: 60px;
    padding-left: 80px;
    padding-bottom: 20px;
  }

  .logo_search_container {
    display: flex;
    width: 100%;
    margin: 0px auto;
  }

  .logo_search_container > img {
    width: 1000px;
    /*width: 65vw;*/
    height: 500px;
    margin: auto;
  }

  .merchant_wrapper {
    width: 1000px;
    /*width: 960px;*/
    /*width: 65vw;*/
    margin: 0px auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    /*padding: 0 20px;*/
  }

  hr {
    border: 1px solid #eee;
    width: 100%;
    margin: 20px 0;
  }

  .merchant_desc div:first-child {
    font-size: 24px;
    color: #000;
    font-weight: bold;
  }

  .merchant_desc div {
    line-height: 30px;
    /*font-size: 14px;*/
    /*color: #999;*/
  }

  .pay_wrapper {
    /*border: 1px solid red;*/
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }

  .pay_title {
    font-size: 18px;
    color: #333;
    line-height: 24px;
    font-weight: bold;
  }

  .pay_box {
    width: 160px;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 8px;
    border: 1px solid #999;
    display: flex;
    flex-direction: row;
  }

  .pay_box_selected {
    width: 160px;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 8px;
    border: 2px solid #FF9933;
    display: flex;
    flex-direction: row;
  }

  .pay_box:hover {
    cursor: pointer;
  }

  .pay_box_selected:hover {
    cursor: pointer;
  }

  .pay_tips {
    font-size: 12px;
    color: #999;
  }

  .pay_button_wrapper {
    display: flex;
    justify-content: right;
    margin-bottom: 140px;
  }

  .pay_button {
    margin-left: 30px;
    height: 40px;
  }

  /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
    background: #99CCFF !important;
    cursor:pointer !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/OrderConfirm/OrderConfirm.vue